<app-loader></app-loader>
<router-outlet>
    <app-loader></app-loader>
</router-outlet>
<span class="badge __version">v{{version}}</span>